module.exports = __webpack_public_path__ + "img/chips5.7c26f0d3.webp";